import CLoader from './Loader.vue'

export {
  CLoader
}

export default {
  CLoader
}
